import moment from 'moment-timezone';

export default function() {
	return function(input,userTimeZone) {
		return input ? moment(input).tz(userTimeZone).format('L') : '-';
	};
};
